import api from '../lib/axios';
export async function searchGeoCommunes(query, limit = 20) {
    const { data } = await api.get('/api/v1/geo-communes', {
        params: { q: query, limit },
    });
    return data.data;
}
export async function getCoverage() {
    const { data } = await api.get('/api/superadmin/coverage');
    return data.data;
}
